export default __webpack_public_path__ + "static/media/back.522756de.svg";